import React from 'react';
import { Sym } from '../../../ui';

/* ============================================================================
 * ActivityRow — single "실시간 활동" event row (warn/info/sys severities).
 * Ported from the Claude Design prototype (admin-dashboard.jsx) to TSX.
 * ========================================================================= */

export type ActivitySeverity = 'warn' | 'info' | 'sys';

export interface ActivityItem {
  icon: string;
  sev: ActivitySeverity;
  who: string;
  text: string;
  t: string;
}

const SEV_TONE: Record<ActivitySeverity, { c: string; bg: string }> = {
  warn: { c: 'var(--gs-warning)', bg: 'var(--gs-warning-container)' },
  info: { c: 'var(--gs-secondary-40)', bg: 'var(--md-sys-color-secondary-container)' },
  sys: { c: 'var(--gs-tertiary-40)', bg: 'var(--md-sys-color-tertiary-container)' },
};

export function ActivityRow({
  a,
  last,
}: {
  a: ActivityItem;
  last: boolean;
}): React.ReactElement {
  const sev = SEV_TONE[a.sev];
  return (
    <div
      style={{
        display: 'flex',
        gap: 12,
        padding: '12px 0',
        borderBottom: last ? 0 : '1px solid var(--md-sys-color-outline-variant)',
      }}
    >
      <div
        style={{
          width: 34,
          height: 34,
          borderRadius: 10,
          flexShrink: 0,
          background: sev.bg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Sym name={a.icon} size={18} fill={1} style={{ color: sev.c }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            font: '400 13px/18px var(--gs-font-kr)',
            color: 'var(--md-sys-color-on-surface)',
          }}
        >
          <span style={{ fontWeight: 600 }}>{a.who}</span> · {a.text}
        </div>
        <div
          style={{
            font: '400 11px/14px var(--gs-font-kr)',
            color: 'var(--md-sys-color-on-surface-variant)',
            marginTop: 3,
          }}
        >
          {a.t}
        </div>
      </div>
    </div>
  );
}
